import { Skeleton } from 'antd';
import { NftPriceSummarySkeleton } from 'components/Shared/NftPriceSummary/Skeleton';
import * as Styled from './styles';

export const NftPurchaseBlockSkeleton = () => {
  return (
    <Styled.PurchaseWrapper>
      <Styled.NftDetailsPlainSection>
        <NftPriceSummarySkeleton />
      </Styled.NftDetailsPlainSection>
      <Styled.PurchaseBlock>
        <Skeleton.Button
          active
          block
          style={{
            borderRadius: 12,
            height: 44,
            margin: 0
          }}
        />
      </Styled.PurchaseBlock>
    </Styled.PurchaseWrapper>
  );
};
